<template>
  <div class="ma-4">
      <v-snackbar v-model="msg" top>{{ text }}<v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar>
  <StaffNav class="hideOnPrint"/>
  <v-row class="hideOnPrint">
  <v-col cols="12" lg="3" xl="2">
    <StaffSide/>
  </v-col>
  <v-col cols="12" lg="9" xl="10">
  <v-data-table
    :headers="headers"
    :items="inspections"
    sort-by="Date"
    sort-desc
    class="elevation-1"
    :loading="isLoading"
    loading-text="Loading Vehicle Inspections"
    :search="search"
    height="550"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Vehicle Inspections</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          label="search"
          class="desktop"
        ></v-text-field>
        
        <v-spacer></v-spacer>
        <report-list-actions
          :reportOptions="reportOptions"
          :downloadFilename="reportListFilename"
        ></report-list-actions>

        <v-dialog v-model="dialog" max-width="100%">
          <template v-slot:activator="{ on }">
            <v-btn v-if="!isAuditorRole" color="#2b3990" class="mb-2 white--text" v-on="on" @click="showAdd()"
              >
              <v-icon left>add</v-icon>
              Add Inspection</v-btn
            >
          </template>
<!-- 
          <VehicleInspectionForm
            :vehicleData="vehicle"
            :documents="documents"
            :imageNames="newImage"
            :mode="vehicleInspectionMode"
            :VehicleType="VehicleType"
            v-on:closeVehicleInspectionForm="closeVehicleInspectionForm($event)"
            v-on:print-vehicle-item="printItem()"
            ></VehicleInspectionForm> -->
        </v-dialog>
      </v-toolbar>
      <v-text-field
        v-model="search"
        clearable
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="search"
        label="search"
        class="mobile ml-5 mr-5 mb-3 mt-3"
      ></v-text-field>
    </template>

   <template v-slot:item.actions="{ item }"  >

      <v-icon small class="mr-2" @click="viewInspection(item)">
        mdi-eye
      </v-icon>

      <v-icon v-if="!isAuditorRole" small @click="deleteInspection(item)">
        mdi-delete
      </v-icon>

    </template>

    <template v-slot:no-data>
      <v-btn color="#2b3990" class="white--text" @click="getInspections()">Reset</v-btn>
    </template>
  </v-data-table>
  </v-col>
  </v-row>
  <Foot class="hideOnPrint"/>
  <div id="printTable">
    <report-header>
      <h2> {{ staffName }} Vehicle Inspections</h2>
    </report-header>
    <v-row>
      <v-col cols="12" sm="12">
          <v-data-table
            :headers="printHeader"
            :items="inspections"
            sort-by="Date"
            sort-desc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Vehicle Inspections"
            :search="search"
            height="auto"
            hide-default-footer
            disable-pagination
          >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Vehicle Inspection</v-toolbar-title>

            </v-toolbar>

          </template>

        </v-data-table>
      </v-col>
    </v-row>

  </div>

  <div id="printItem">
    <report-header>
      <h2> {{ staffName }} Vehicle Inspection</h2>
    </report-header>
    
    <table style="width:100%">
      <tr>
        <th style="width:30%">
          Vehicle
        </th>
        <td>
          {{ vehicle.VehicleType }}
        </td>
      </tr>
      <tr 
        v-if="VehicleType == 'Other'"
      >
        <th>
          Other
        </th>
        <td>
          {{ newOtherVehicleType }}
        </td>
      </tr>
      <tr>
        <th>
          Starting Miles
        </th>
        <td>
          {{ vehicle.Start }}
        </td>
      </tr>
      <tr>  
        <th>
          Ending Miles
        </th>
        <td>
          {{ vehicle.End }}
        </td>
      </tr>
      <tr>
        <th>
          Date
        </th>
        <td>
          {{ vehicle.Date }}
        </td>
      </tr>
      <tr>
        <th>
          Description of Activity
        </th>
        <td>
          {{ vehicle.Description }}
        </td>
      </tr>
      <tr v-for="(image, index) in documents" :key=index>
        <th>
          Document {{ index + 1}}
        </th>
        <td> 
          <v-img :src="image.AWSLink" />
        </td>
      </tr>
      <tr>
        <th>
          Staff Check In Signature
        </th>
        <td>
          {{ vehicle.CheckInSignature }}
        </td>
      </tr>
      <tr>
        <th>
          Staff Check Out Signature
        </th>
        <td>
          {{ vehicle.CheckOut }}
        </td>
      </tr>
      <tr>
        <th>
          Notes or Repair From Trip
        </th>
        <td>
          {{ vehicle.Notes }}
        </td>
      </tr>
      <tr>
        <th colspan="2"><h3 class="pt-6">INTERIOR</h3>
          <hr />
        </th>
      </tr>
      <tr>
        <th>
          Current Registration and Insurance (Sealed Envelope)
        </th>
        <td>
          {{ vehicle.Registration }}
        </td>
      </tr>
      <tr>
        <th>
          Gauges (any engine lights, dash lights on)
        </th>
        <td>
          {{ vehicle.Gauges }}
        </td>
      </tr>
      <tr>
        <th>
          Air Condition / Heat Working
        </th>
        <td>
          {{ vehicle.Heater }}
        </td>
      </tr>
      <tr>
        <th>
          Fire Extinguisher
        </th>
        <td>
          {{ vehicle.Fire }}
        </td>
      </tr>
      <tr>
        <th>
          First Aid Kit
        </th>
        <td>
          {{ vehicle.FirstAid }}
        </td>
      </tr>
      <tr>
        <th>
          All Seatbelts Functional
        </th>
        <td>
          {{ vehicle.Seatbelts }}
        </td>
      </tr>
      <tr>
        <th>
          Vehicle Clean Inside
        </th>
        <td>
          {{ vehicle.Inside }}
        </td>
      </tr>
      <tr>
        <th>
          Rear View Mirror
        </th>
        <td>
          {{ vehicle.RearView }}
        </td>
      </tr>
     
      <tr>
        <th colspan="2"><h3 class="pt-6">EXTERIOR</h3>
          <hr />
        </th>
      </tr>
      <tr>
        <th>
          Tire Treads or Crack on Tires
        </th>
        <td>
          {{ vehicle.TireTread }}
        </td>
      </tr>
      <tr>
        <th>
          Vehicle Clean Outside
        </th>
        <td>
          {{ vehicle.Outside }}
        </td>
      </tr>
      <tr>
        <th>
          Date of Carwash
        </th>
        <td>
          {{ vehicle.CarWashDate }}
        </td>
      </tr>
      <tr>
        <th>
          Any Damages to Exterior of Vehicle
        </th>
        <td>
          {{ vehicle.Damages }}
        </td>
      </tr>
      <tr>
        <th>
          Damages Explanation (if any)
        </th>
        <td>
          {{ vehicle.DamageExplanation }}
        </td>
      </tr>
      <tr>
        <th>
          Side Mirrors Intact and Working
        </th>
        <td>
          {{ vehicle.Mirrors }}
        </td>
      </tr>
      <tr>
        <th>
          Spare Tire
        </th>
        <td>
          {{ vehicle.Spare }}
        </td>
      </tr>
      <tr>
        <th colspan="2"><h3 class="pt-6">MECHANICAL</h3>
          <hr />
        </th>
      </tr>
      <tr>
        <th>
          Windows Clean and Wipers Functional
        </th>
        <td>
          {{ vehicle.Windows }}
        </td>
      </tr>
      <tr>
        <th>
          Reverse and Brake Lights Working
        </th>
        <td>
          {{ vehicle.Reverse }}
        </td>
      </tr>
      <tr>
        <th>
          Hazard Lights Working
        </th>
        <td>
          {{ vehicle.Hazard }}
        </td>
      </tr>
      <tr>
        <th>
          Head Lights Working
        </th>
        <td>
          {{ vehicle.Lights }}
        </td>
      </tr>
      <tr>
        <th>
          Turn Signals Working
        </th>
        <td>
          {{ vehicle.Signals }}
        </td>
      </tr>
      <tr>
        <th>
          Horm Working
        </th>
        <td>
          {{ vehicle.Horn }}
        </td>
      </tr>
      <tr>
        <th>
          Any Unexplained Puddles Under Vehicle
        </th>
        <td>
          {{ vehicle.Puddles }}
        </td>
      </tr>
    </table>
  </div>

  </div>
</template>

<script>
import axios from 'axios'
import Foot from '@/components/Footer'
import StaffNav from '@/components/StaffNav'
import StaffSide from '@/components/StaffSide'
import moment from 'moment'
// import VehicleInspectionForm from './client/VehicleInspection/VehicleInspectionForm'
import ReportHeader from '@/components/Report/ReportHeader.vue'
import ReportListActions from '@/components/Report/ReportListActions.vue'

const url = require("../../../client_config/config").url;

export default {
components: {
  Foot,
  StaffNav,
  StaffSide,
  // VehicleInspectionForm,
  ReportHeader,
  ReportListActions,
},
data: function() {
  return {
    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: true,
        value: 'Date',
      },
      { text: "Starting Miles", value: "Start" },
      { text: "Ending Miles", value: "End" },
      { text: "Vehicle", value: "VehicleType" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    dialog: false,
    editInspection: false,
    newInspection: false,
    msg: false,
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    search: "",
    text:"",
    inspections: [],
    formMode: 'add',
    vehicles: [
      "2009 Ford Expedition UTAH",
      "2009 Ford Expedition NEVADA",
      "2010 Ford E350 Van",
      "2017 Kia Sedona",
      "2019 RAM Pro Master Van",
      "2022 Ford Transit",
      "2022 Toyota Sienna Minivan White",
      "Nissan Titan",
      "Other",
      "No"
    ],
    userID: localStorage.getItem('userID'),
    employeeID: localStorage.getItem("staffId"),
    userState: localStorage.getItem('userState'),
    titleForm: "New Inspection",
    inspectionID: "",
    newImage: [],
    isLoading: true,
    checkInSignature: false,
    checkOutSignature: false,
    uploadImg: "",
    OtherVehicleType: "",
    newVehicles: [],
    vehicle: {},
    vehicleInspectionMode: 'add',
    newImageLink: "",
    documents:[],
    VehicleType:'',
    newVehicleType: '',
    newStart: '',
    newEnd: '',
    newDate: '',
    newInside: '',
    newOutside: '',
    newRegistration: '',
    newSpare: '',
    newSeatCovers: '',
    newPassSide: '',
    newDriverSide: '',
    newFront: '',
    newRear: '',
    newRoof: '',
    newWindshield: '',
    newWindows: '',
    newPassMirror: '',
    newDriverMirror: '',
    newTiresFront: '',
    newTiresRear: '',
    newCap: '',
    newLeaks: '',
    newLights: '',
    newSignals: '',
    newReverse: '',
    newHazard: '',
    newFuel: '',
    newHeater: '',
    newHorn: '',
    newDash: '',
    newRearView: '',
    newGauges: '',
    newRadio: '',
    newWipers: '',
    newFrontSeats: '',
    newFrontRow: '',
    newBackRow: '',
    newSeatbelts: '',
    newCarpet: '',
    newCeiling: '',
    newFirstAid: '',
    newFire: '',
    newDescription: '',
    newCheckIn: '',
    newCheckOut: '',
    newNotes: '',
  };
},

computed: {

  formTitle() {
    return this.formMode === 'add' ? "New Item" : "Edit Item";
    },

  vehicleText() {
    return function (item) {
      // Concatenate the desired fields (e.g., Make, Model, Year)
      return `${item.Year} ${item.Make} ${item.Model}`;
    };
  },

  newShiftColor: {
    get () {
      return this[this.typeColor]
    },
    set (v) {
      this[this.typeColor] = v
    },
  },
  staffName() {
    // `this` points to the component instance
    return localStorage.getItem('Name') ? localStorage.getItem('Name') : this.$store.state.staff.staff?.Name;
  },  

  selectedEmployee() {
    return this.$store.state.users.allUsers.find(
        (user) => user._id == this.employeeID
    )
  },

  employeeName() {
    return this.selectedEmployee.Name ?? this.staffName
  }, 

  reportOptions() {
    return { 
      query: {
        name: this.employeeName,
      },
      endpoints: `inspections/printList/${this.employeeID}`,
      dynamic: true
    }
  },
  reportListFilename() {
    return `${this.employeeName} - Vehicle Inspection`
  },
  isAuditorRole() {
    return localStorage.getItem("userRole") === 'Auditor'
  },
  printHeader() {
    return this.headers;
  }
},

created() {
  this.employeeID = this.$route.params.employeeID
  this.getInspections();
  this.getVehicles();
},

methods: {
  show(){
    //console.log(this.newVehicleType)
  },
  initialize() {
    this.inspections = [];
  },

  getVehicles() {
      this.isLoading = true;
      axios.get(`${url}/vehicles/active/${this.userState}`).then(res => {
          this.newVehicles = res.data.vehicles;

      }).finally(() => this.isLoading = false);
    },

  viewInspection(item) {
      this.$router.push({
        path: `/VehicleInspection/${this.employeeID}/edit`,
        query: { id: item._id, new: false },
      });
  },

  showAdd() {
    this.$router.push({
        path: `/VehicleInspection/${this.employeeID}/add`,
      });
  },

  deleteInspection(item) {
    const id = item._id;
    confirm("Are you sure you want to delete this inspection?") &&
    this.inspectionDelete(id);

  },

  inspectionDelete(id) {
    axios.delete(`${url}/inspections/${id}`)
    .then((response) => {
      this.getInspections();
      if (response.status == 400) {
        response.json().then(function(data) {
          return data.msg;
        });
      }
      this.msg=true;
      this.text="The inspection has been deleted successfully.";
    });
  },

  getInspections: async function() {
    this.isLoading = true;
    await axios.get(`${url}/inspections/staff/${this.employeeID}`).then(res => {
      this.inspections = res.data.inspections.map(item => (
        {
          ...item,
          Date: item.Date !== "Invalid date" && item.Date !== '' ? moment(item.Date).format("YYYY-MM-DD") : ''
        }
      ))
    }).finally(() => this.isLoading = false);
  },

  clearData() {},

  closeVehicleInspectionForm(data) {
    this.getInspections();

    if (data.message !== '') {
      this.msg = true;
      this.text = data.message;
    }
    this.dialog = false;
    this.inspectionID = data._id;
    this.vehicle = {};
    this.clearData();

    this.getInspections();
  },

  imgSelected(e) {
     this.uploadImg=e;
  },

  deleteChip(index) {
        this.removedDocuments.push(this.documents[index]);
        this.documents.splice(index, 1);
  },

  signCheckIn() {
        this.vehicleData.CheckIn = localStorage.getItem('Name') + " - " + new Date()
  },

  signCheckOut() {
        this.vehicleData.CheckOut = localStorage.getItem('Name') + " - " + new Date()
  },

  printTable() {
      document.getElementById('printTable').style.display = "block";
      document.getElementById('printItem').style.display = "none";

      window.print()

      document.getElementById('printTable').style.display = "none";
  },
  printItem() {
      document.getElementById('printItem').style.display = "block";
      document.getElementById('printTable').style.display = "none";
      document.getElementsByClassName('v-overlay__scrim')[0].style.backgroundColor = "transparent";
    
      window.print()

      document.getElementById('printItem').style.display = "none";

  },
},

};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}

#printTable{
  display: none;
}

#printItem{
  display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }

  @media print {
    #printTable{
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;

    }
    #printItem{
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;


    }
    .hideOnPrint {
      display: none;
      border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
      display: none;
      border: none;

    }
    .outlined {
      border-width: .5px solid black
    }

    @page { margin: 0; }
    body { margin: 1.6cm; }


  }
</style>

